import DeleteIcon from "@mui/icons-material/Delete";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { useDeleteBenutzer, useDeleteLieferant } from "../../client/hooks";
import { useMutation, useQueryClient } from "react-query";
import {
  bindPopover,
  bindTrigger,
  usePopupState,
} from "material-ui-popup-state/hooks";

export default function DeleteBenutzerButton({ id }: { id: string }) {
  const mutate = useLoeschenBenutzer(id);
  const popupState = usePopupState({
    variant: "popover",
    popupId: `Benutzer-${id}-deactivate`,
  });
  return (
    <>
      <IconButton
        sx={{ position: "absolute", top: 10, right: 10 }}
        {...bindTrigger(popupState)}
        aria-label="delete"
      >
        <DeleteIcon />
      </IconButton>
      <Dialog {...bindPopover(popupState)}>
        <DialogTitle id="alert-dialog-title">
          Benutzer wirklich löschen
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Sie sind dabei den Benutzer zu löschen. Sind Sie sicher?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => popupState.close()} color="inherit">
            abbrechen
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              mutate.mutate();
              popupState.close();
            }}
          >
            löschen
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
function useLoeschenBenutzer(id: string) {
  const deleteBenutzer = useDeleteBenutzer();
  const queryClient = useQueryClient();

  return useMutation(
    () => {
      return deleteBenutzer(id);
    },
    {
      onSuccess: async () => {
        queryClient.invalidateQueries(["benutzer", id]);
      },
    }
  );
}
